import React from 'react';
import { Sparkles, Heart, Eye, RefreshCw, Trophy, Shield, CheckCircle } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      icon: <Sparkles className="w-8 h-8 md:w-10 md:h-10" />,
      title: "CLASSIC DESIGNER COLLECTION",
      description: "Exclusive handcrafted masterpieces blending timeless elegance with contemporary artistry. Each piece tells a unique story.",
      color: "text-amber-500",
      bgColor: "bg-amber-50",
      hoverColor: "group-hover:bg-amber-500"
    },
    {
      icon: <Heart className="w-8 h-8 md:w-10 md:h-10" />,
      title: "100% SATISFACTION",
      description: "Your happiness is our ultimate goal. We ensure every purchase exceeds your expectations with premium quality service.",
      color: "text-rose-500",
      bgColor: "bg-rose-50",
      hoverColor: "group-hover:bg-rose-500"
    },
    {
      icon: <Eye className="w-8 h-8 md:w-10 md:h-10" />,
      title: "TRANSPARENCY",
      description: "Full disclosure on gemstone origins, metal purity, and pricing. No hidden costs, no surprises - just honest business.",
      color: "text-cyan-500",
      bgColor: "bg-cyan-50",
      hoverColor: "group-hover:bg-cyan-500"
    },
    {
      icon: <RefreshCw className="w-8 h-8 md:w-10 md:h-10" />,
      title: "100% GUARANTEED EXCHANGE",
      description: "Change of heart? We've got you covered! Hassle-free exchange within 30 days. Your satisfaction is our promise.",
      color: "text-emerald-500",
      bgColor: "bg-emerald-50",
      hoverColor: "group-hover:bg-emerald-500"
    },
    {
      icon: <Trophy className="w-8 h-8 md:w-10 md:h-10" />,
      title: "BEST PRICE GUARANTEED",
      description: "Direct sourcing from artisans means unmatched value. Find a lower price elsewhere? We'll match it instantly!",
      color: "text-purple-500",
      bgColor: "bg-purple-50",
      hoverColor: "group-hover:bg-purple-500"
    },
    {
      icon: <Shield className="w-8 h-8 md:w-10 md:h-10" />,
      title: "TRUSTWORTHY",
      description: "40+ years of excellence, thousands of happy customers, and a legacy of trust with lifetime quality assurance.",
      color: "text-orange-500",
      bgColor: "bg-orange-50",
      hoverColor: "group-hover:bg-orange-500"
    }
  ];
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-50 to-amber-50 px-5 py-2 rounded-full mb-5">
            <CheckCircle className="w-4 h-4 text-blue-600" />
            <span className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Why Choose Royal Gems</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-blue-600">Our</span>
            <span className="text-amber-600"> Promise</span>
            <span className="text-gray-800"> to You</span>
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Experience the Royal Gems difference with our unmatched commitment to quality, transparency, and customer delight
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 md:gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group text-center p-5 rounded-xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer bg-white border border-gray-100"
            >
              <div className={`${feature.bgColor} w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-all duration-300 group-hover:shadow-lg`}>
                <div className={`${feature.color} group-hover:text-white transition-colors duration-300`}>
                  {feature.icon}
                </div>
              </div>
              <h3 className="text-xs md:text-sm font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;